import type { SVGProps } from 'react'

/** Íconos inline (trazo de 24 px, estilo lineal), sin librería. */
const paths = {
  sun: 'M12 4V2M12 22v-2M4 12H2M22 12h-2M5.6 5.6 4.2 4.2M19.8 19.8l-1.4-1.4M5.6 18.4l-1.4 1.4M19.8 4.2l-1.4 1.4M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z',
  moon: 'M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z',
  monitor: 'M3 5h18v11H3zM8 20h8M12 16v4',
  logout: 'M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3M10 16l-4-4 4-4M6 12h10',
  plus: 'M12 5v14M5 12h14',
  cloud: 'M7 18h10a4 4 0 0 0 .6-8A6 6 0 0 0 6 9.5 4.3 4.3 0 0 0 7 18Z',
  cloudOff: 'M3 3l18 18M8 8.3A6 6 0 0 0 6 9.5 4.3 4.3 0 0 0 7 18h10M17.6 10a4 4 0 0 1 2.8 6.4M10.5 6.2A6 6 0 0 1 17.6 10',
  refresh: 'M20 12a8 8 0 1 1-2.3-5.7M20 4v5h-5',
  note: 'M6 3h9l4 4v14H6zM14 3v5h5M9 13h6M9 17h4',
  back: 'M15 18l-6-6 6-6',
  pen: 'M4 20l1-4L16 5l3 3L8 19zM14 7l3 3',
  finger: 'M9 11V4.5a1.5 1.5 0 0 1 3 0V11M12 10.5a1.5 1.5 0 0 1 3 0V12M15 11.5a1.5 1.5 0 0 1 3 0V15a6 6 0 0 1-6 6h-1a6 6 0 0 1-4.8-2.4L3.6 15a1.5 1.5 0 0 1 2.3-1.9L9 15.5',
  hand: 'M12 3v18M3 12h18M12 3l-3 3M12 3l3 3M12 21l-3-3M12 21l3-3M3 12l3-3M3 12l3 3M21 12l-3-3M21 12l-3 3',
  sheet: 'M6 3h12v18H6zM9 8h6M9 12h6M9 16h6',
  pagePlus: 'M6 3h9l4 4v14H6zM14 3v5h5M12.5 11v6M9.5 14h6',
  highlighter: 'M9 11l-6 6v3h9l3-3M22 12l-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4',
  eraser: 'M7 21h12M4.6 14.6l9.2-9.2a2 2 0 0 1 2.8 0l3 3a2 2 0 0 1 0 2.8L11.4 19H8.6l-4-4a.3.3 0 0 1 0-.4ZM9.5 9.7l5.8 5.8',
  lasso: 'M5.5 17.5C3.4 16 2 13.9 2 11.5 2 7.4 6.5 4 12 4s10 3.4 10 7.5S17.5 19 12 19c-1.2 0-2.4-.2-3.5-.5M5 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM5 20c0 1.2.6 2 2 2',
  undo: 'M9 14 4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11',
  redo: 'm15 14 5-5-5-5M20 9H9.5a5.5 5.5 0 0 0 0 11H13',
  trash: 'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6',
  copy: 'M8 8h12v12H8zM16 8V4H4v12h4',
  check: 'M5 12l5 5L20 7',
  swap: 'M7 16l-4-4 4-4M3 12h18M17 8l4 4-4 4',
  shapes: 'M3 13h8v8H3zM17 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM7 3l4 7H3z',
  more: 'M5 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM19 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z',
  folder: 'M3 6a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z',
  download: 'M12 4v11M7 10l5 5 5-5M5 20h14',
  share: 'M12 15V3M7 8l5-5 5 5M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6',
  info: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 11v5M12 7.5v.5',
  users: 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM2 21v-1a6 6 0 0 1 6-6h2a6 6 0 0 1 6 6v1M16 3.1a4 4 0 0 1 0 7.8M22 21v-1a6 6 0 0 0-4-5.7',
  link: 'M10 14a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1M14 10a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1',
  key: 'M15 3a6 6 0 1 0 0 12 6 6 0 0 0 0-12ZM10.8 13.2 3 21M6 18l3 3M8 16l2 2',
  eye: 'M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z',
  enter: 'M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3',
  x: 'M6 6l12 12M18 6 6 18',
  text: 'M5 6V4h14v2M12 4v16M9 20h6',
  sigma: 'M18 6V4H6l6 8-6 8h12v-2',
  axes: 'M5 3v16h16M5 3 3 5M5 3l2 2M21 19l-2-2M21 19l-2 2M8 15c2-6 4-8 6-8s3 2 5 6',
  numberline: 'M2 12h20M4 10l-2 2 2 2M20 10l2 2-2 2M7 9v6M12 9v6M17 9v6',
  fx: 'M10 4c-2 0-3 1-3 3v13M4 10h6M13 10l6 8M19 10l-6 8',
  edit: 'M4 20h4L19 9l-4-4L4 16zM13 7l4 4',
  minus: 'M5 12h14',
  bold: 'M7 4h6a4 4 0 0 1 0 8H7zM7 12h7a4 4 0 0 1 0 8H7z',
} as const

export type IconName = keyof typeof paths

export function Icon({ name, size = 22, ...rest }: { name: IconName; size?: number } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d={paths[name]} />
    </svg>
  )
}
